import {WorkspaceServerItem} from 'constants/FileBrowserConstants';
import * as net from 'util/Net';

const WorkspaceDAO = {
  update: ({
    itemsPresent,
    deletedIds,
    tabOrder,
  }: {
    itemsPresent: Array<WorkspaceServerItem>;
    deletedIds: Array<string>;
    tabOrder: Array<string>;
  }) =>
    net.postJSON({
      url: '/1/api/workspace-items/actions/sync',
      data: {
        itemsPresent,
        deletedIds,
        tabOrder,
      },
    }),
};
export default WorkspaceDAO;
